import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { arSD } from '@mui/x-data-grid/locales';
import { FormControlLabel, Input, Switch } from '@mui/material';
import { useMaterialUIController } from 'context';
import { useTheme } from '@mui/material/styles';
// Create a theme with Arabic locale and RTL support
/* const theme = createTheme(
  {
    direction: 'rtl',
    typography: {
      fontFamily: '"Noto Sans Arabic", "Roboto", sans-serif',
    },
  },
  arSD
); */


const RTLDataGrid = ({
  rows = [],
  columns = [],
  onDelete = () => {},
  onUpdate = () => {},
  onShow = () => {},
  onActive = () => {},
  isActions = true,
  ...props
}) => {
   const [controller] = useMaterialUIController();
  const darkMode = controller.darkMode;
  const theme = useTheme();
  console.log('🚀 ~ RTLDataGrid ~ rows:', rows);
  console.log('🚀 ~ RTLDataGrid ~ columns:', columns);
  const [checked, setChecked] = React.useState(false);
  // Add Actions column
  const actionColumn = {
    field: 'actions',
    headerName: 'الإجراءات',
    flex: 1.5,
    renderCell: (params) => (
      <div style={{ display:"flex" , alignItems:"center", width:"100%" , justifyContent:"flex-start" }}>
        <Button
         
          color="primary"
          sx={{
            color:"text.border" ,"&:hover": {
              color: "text.main",
            },
          }}
          size="medium"
          startIcon={<VisibilityIcon />}
          onClick={() => onShow(params.row)}
        >
          
        </Button>
        <Button
         
          color="secondary"
          sx={{
            color:"text.border" ,"&:hover": {
              color: "text.main",
            },
          }}
          size="medium"
          startIcon={<EditIcon />}
          onClick={() => onUpdate(params.row)}
        >
        </Button>
        <Button
          color="error"
          size="medium"
          sx={{
            color:"text.border" ,"&:hover": {
              color: "error.main",
            },
          }}
          startIcon={<DeleteIcon />}
          onClick={() => onDelete(params.row)}
        >
        </Button>
      {/*   <FormControlLabel
      control={
        <Switch
          
          onChange={(e) => setChecked(e.target.checked)}
          sx={{
            '& .MuiSwitch-switchBase.Mui-checked': {
              color: '#1976d2', // Color when toggle is ON
            },
            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
              backgroundColor: '#1976d2', // Track color when ON
            },
            '& .MuiSwitch-switchBase': {
              color: '#ccc', // Color when toggle is OFF
            },
            '& .MuiSwitch-track': {
              backgroundColor: '#666', // Track color when OFF
            },
          }}
        />
      }
      
    /> */}
          
          
      </div>
    ),
  };

  // Combine provided columns with Actions column
  const allColumns =  isActions ? [...columns, actionColumn] : [...columns];
  console.log('🚀 ~ allColumns ~ allColumns:', allColumns);
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div style={{ height: 400, width: '100%', direction: 'rtl' , color:"text.main" , bgcolor:"red" , border:"none" , boxShadow:"none" }}>
       <DataGrid
  border={false}
  rows={rows}
  columns={allColumns}
  pageSizeOptions={[5, 10, 20]}
  initialState={{
    pagination: { paginationModel: { pageSize: 10 } },
  }}
  localeText={arSD.components.MuiDataGrid.defaultProps.localeText}
  sx={{
    color:"text.main",
    // 1. General Grid Background
    bgcolor: "inherit", // Change this to your desired grid background color
    border: "none",
    borderTop: "none",
    // 2. Customizing the Header Background
    '& .MuiDataGrid-columnHeaders': {
      bgcolor: "#f5f5f5", // Change this to your desired header color
      color:"text.main",
      borderBottom: "none !important ",
      border:"none !important",
     // Optional: Adds a separator below headers
    },
    
    // 3. Creating a "Break" between rows
    // (We use a thick bottom border that matches your page background to simulate a gap)
    '& .MuiDataGrid-row': {
     
      // Optional: Add hover effect to make rows stand out
     
    },

    // Removing default focus outlines (from your original code)
    '& .MuiDataGrid-cell:focus-within': {
      outline: 'none',
      outlineOffset: 0,
    },
    
    // Removing the default cell border if you want a cleaner "card" look
    '& .MuiDataGrid-cell': {
      borderBottom: 'none !important',
      border:"none !important", 
      color:"text.main",
      display:"flex",
      
      alignItems:"center",
    },
    "& .MuiToolbar-root-MuiTablePagination-toolbar": {
      color:"text.main",
    },
    "& .MuiDataGrid-footerContainer": {
      color:"text.main",
    },
    "& ..MuiDataGrid-withBorderColor": {
     borderColor:"text.border",
    },
    "& .MuiTablePagination-root":{
      color:"text.main",
    },
    "& .MuiButtonBase-root-MuiIconButton-root":{
      color:"text.main",
    },
    "& .MuiButtonBase-root-MuiIconButton-root.Mui-disabled":{
      color:"text.border",
    },
   
    
    
  }}
  {...props}
/>
      </div>
    </ThemeProvider>
  );
};

export default RTLDataGrid;